import './styles/app-shell.scss';
import { createSSRApp } from 'vue';
import App from './App.vue';
import createRouter from './router';
import createStore from './store';
import globalUtil from '@/utlis/global';
import UAParser from 'ua-parser-js';

/**
 * 创建 SSR 与客户端共用的应用实例
 * @param {{ deviceType?: string, userAgent?: string }} ssrContext 服务端传入的 UA / 设备类型
 */
export function createApp(ssrContext = {}) {
	const router = createRouter();
	const store = createStore();
	const app = createSSRApp(App);

	app.use(router);
	app.use(store);

	const uaString = ssrContext.userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
	const uaParser = new UAParser(uaString);
	const deviceInfo = uaParser.getResult();
	const isMobileDevice = deviceInfo.device.type === 'mobile';

	app.config.globalProperties.$global = globalUtil;
	app.config.globalProperties.$server = globalUtil.server;
	app.config.globalProperties.$ua = {
		deviceInfo,
		isMobileDevice,
	};
	// 服务端无 analytics 时的安全占位
	app.config.globalProperties.$logEvent = (event, params = {}) => {
		if (import.meta.env.SSR) return;
		console.log('[analytics]', event, params);
	};

	const deviceType = ssrContext.deviceType || (isMobileDevice ? 'mobile' : 'desktop');
	app.provide('deviceType', deviceType);

	return { app, router, store };
}
